export default {
	init() {

	jQuery(document).ready(function($){

		$(function() {
			var selectedClass = "",
				portfolio = $("#portfolio");
				$(".fil-cat").click(function(){
				$('.fil-cat').removeClass('portfolio-nav-active');
				$(this).addClass('portfolio-nav-active');
				
				selectedClass = $(this).attr("data-rel");
									
					portfolio.fadeOut(100, function(){
					$('.scale-anm').removeClass('mm_third-col');
						$("#portfolio div.col-md-6").fadeOut(0, 'swing', function(){
							$("#portfolio div.col-md-6").removeClass('scale-anm');
							$("."+selectedClass).addClass('scale-anm').fadeIn(0);
							$('.scale-anm').each(function(index){
								if ((index + 1) % 3 === 0) {
									$(this).addClass('mm_third-col');
								}
							});
							portfolio.fadeTo(200, 1);
						});
					});
				});
		});

	});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};



// WEBPACK FOOTER //
// ./scripts/routes/ourwork.js